export default __webpack_public_path__ + "static/media/save-icon.eec0ad32.svg";